/**
 * Auto-reload the page when a new service worker takes control.
 *
 * `vite-plugin-pwa` is configured with `registerType: 'autoUpdate'`,
 * which means the SW calls `skipWaiting()` + `clientsClaim()` as soon
 * as a new build is detected — but the *currently-rendered* page
 * keeps running the old JS bundle until something triggers a reload.
 * On iOS standalone PWAs that "something" rarely happens on its own:
 * resume from the app switcher doesn't reload, and removing the
 * home-screen icon doesn't clear the SW (it's bound to the origin,
 * not the icon).
 *
 * `controllerchange` fires the moment a new SW claims the page, so
 * reloading then is the canonical fix: the new SW serves the new
 * bundle on the very next request. The `hadController` guard avoids
 * a wasteful reload on first install — when no SW was controlling
 * the page before, claiming it doesn't mean there's a newer version
 * to load, just that one exists at all.
 */
export function registerServiceWorkerAutoReload() {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
    return;
  }
  const hadController = Boolean(navigator.serviceWorker.controller);
  let reloading = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!hadController) return;
    if (reloading) return;
    reloading = true;
    window.location.reload();
  });
}
